/**
 * Évènements du store
 */
export const StoreKeys = {
  USER_INFO: 'userInfoDto',
  PERIMETRE: 'perimetre',
  NB_DEMANDES_EN_COURS: 'nbDemandesEnCours',
  SELECTED_SIREN: 'selectedSiren',
  BANDEAU_METEO: 'bandeauMeteo',
  TACHES_TEMP: 'tachesTemp',
  TACHES: 'taches',
  SIREN_COMPETENCES: 'sirenCompetences',
};
